import { ElementTransformer } from '@lexical/markdown';
import { $isParagraphNode, LexicalNode } from 'lexical';
import { $createImageNode, $isImageNode, ImageNode } from '../nodes';

// Matches standard markdown image syntax: ![alt text](https://example.com/image.png)
const IMAGE_REGEX = /^!\[([^\]]*)\]\(([^)\s]+)\)\s*$/;

const convertNode = (node: ImageNode) => `![${node.getAlt()}](${node.getSrc()})`;

export const IMAGE_TRANSFORMER: ElementTransformer = {
  dependencies: [ImageNode],

  // Node -> markdown
  export: (node: LexicalNode) => {
    if ($isImageNode(node)) {
      return convertNode(node);
    }
    if ($isParagraphNode(node)) {
      const children = node.getChildren();
      const imageNodes = children.filter($isImageNode);
      if (imageNodes.length > 0) {
        return imageNodes.map(convertNode).join('\n');
      }
    }
    return null;
  },

  regExp: IMAGE_REGEX,

  // Markdown -> node
  replace: (parentNode, _children, match) => {
    const [, alt, src] = match;
    const imageNode = $createImageNode(src, alt);
    // parentNode is the ParagraphNode wrapping the matched line, replace it entirely with the ImageNode
    parentNode.replace(imageNode);
  },

  type: 'element',
};
